import { HTMLAttributes } from 'react'

export const FileWithArrowUp = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='30'
    height='30'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_195_24157'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='3'
      y='2'
      width='18'
      height='20'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.5 3.75C5.80964 3.75 5.25 4.30964 5.25 5V19C5.25 19.6904 5.80964 20.25 6.5 20.25H17.5C18.1904 20.25 18.75 19.6904 18.75 19V9.75H15.75C14.2312 9.75 13 8.51878 13 7V3.75H6.5ZM18.3754 8.14735C18.4087 8.17996 18.4399 8.21425 18.469 8.25H15.75C15.0596 8.25 14.5 7.69036 14.5 7V4.34504L18.3754 8.14735ZM3.75 5C3.75 3.48122 4.98122 2.25 6.5 2.25H13.3827C14.103 2.25 14.7945 2.53259 15.3086 3.03703L19.4259 7.07663C19.953 7.59378 20.25 8.30118 20.25 9.03961V19C20.25 20.5188 19.0188 21.75 17.5 21.75H6.5C4.98122 21.75 3.75 20.5188 3.75 19V5ZM12.5349 10.9247C12.242 10.6319 11.7671 10.6319 11.4742 10.9247L9.01967 13.3793C8.72678 13.6722 8.72678 14.1471 9.01967 14.44C9.31256 14.7328 9.78744 14.7328 10.0803 14.44L11.2545 13.2657V17.4551C11.2545 17.8693 11.5903 18.2051 12.0045 18.2051C12.4188 18.2051 12.7545 17.8693 12.7545 17.4551V13.2657L13.9288 14.44C14.2217 14.7328 14.6965 14.7328 14.9894 14.44C15.2823 14.1471 15.2823 13.6722 14.9894 13.3793L12.5349 10.9247Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_195_24157)'>
      <path d='M24 0H0V24H24V0Z' fill='#808080' />
    </g>
  </svg>
)
